import { render, staticRenderFns } from "./PartialBodyMap.vue?vue&type=template&id=7a76012d&scoped=true&"
import script from "./PartialBodyMap.vue?vue&type=script&lang=js&"
export * from "./PartialBodyMap.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/components/views/dashboard/members/id/partial-body-map.scss?vue&type=style&index=0&id=7a76012d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a76012d",
  null
  
)

export default component.exports